// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"project-preview-module--previewTitle--2Sayq","previewImage":"project-preview-module--previewImage--35_Lr"};